import { render } from "./AbilitiesSection.vue?vue&type=template&id=26a8ecb9&scoped=true"
import script from "./AbilitiesSection.vue?vue&type=script&lang=js"
export * from "./AbilitiesSection.vue?vue&type=script&lang=js"

import "./AbilitiesSection.vue?vue&type=style&index=0&id=26a8ecb9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26a8ecb9"]])

export default __exports__